/** Tracks API endpoints, merged into the platform API client. */
export const tracksApiEndpoints: Record<string, string> = {
  projectTracks: "/ext/tracks/projects/:pk/",
  saveProjectTracks: "PUT:/ext/tracks/projects/:pk/",
  myTracks: "/ext/tracks/projects/:pk/mine/",
  chooseTrack: "POST:/ext/tracks/projects/:pk/mine/",
  tracksProgress: "/ext/tracks/projects/:pk/progress/",
};
